export default __webpack_public_path__ + "static/media/store-owner-vegshelf.2172e9d1.png";